$(document).ready(function () {
    // correctif du bug sur le lien contact
    $(".bt-menu-contact").click(function() {
        if ((typeof $('#header-burger').attr('aria-expanded') !== "undefined")) {
            $('#header-burger').trigger('click');
        }
    });
});



